<template>
    <div style="height: calc(100% - 48px)">
        <apexchart v-if="series.length > 0" width="100%" height="100%" type="line" :options="options" :series="series"></apexchart>

    </div>
</template>
<script>
export default ({
    data() {
        return {
            options: {

annotations: {
  yaxis: [
    {
      y: 1000,
      borderColor: '#FF0000',
      label: {
        borderColor: '#FF0000',
        style: {
          color: '#fff',
          background: '#FF0000'
        },
        text: 'Covid19 Positiv (ROX)'
      }
    },
  ]
},
                legend: {
                    show: true,
                },
                stroke: {
                    width: 1,
                    curve: 'smooth',
                },
                chart: {               
                toolbar: {
                    show: false,
                },                    
                    id: 'chart0'
                },
            },            
            series: [],
        }
    },
    mounted() {
        this.$store.dispatch("LoadTest", this.$route.params.testid)
        .then((r) => {
            r.filter(e => e.wellTarget=="ROX").forEach((r) => {
                var vxp = [];
                r.wellDataAmp.split(",").forEach((cc) => {
                    vxp.push(parseFloat(cc))
                })
                this.series.push({
                    name: r.wellBarcode,
                    data: vxp,
                })
            })
        })
    },
})
</script>
